module.exports = __webpack_public_path__ + "static/img/rota-do-mar-clube.801d8425.svg";